export default "__VITE_ASSET__7e8f7c19__"